import { Typography, Button, Box, Hidden } from '@mui/material';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from 'components/core/Grid';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { generateDatesDisplay } from 'components/views/pages/Checkout/helpers';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';

const StyledButton = styled(Button)`  
  justify-content: flex-start;  
  text-transform: none;
  text-align: left;  
  color:  ${props => props.theme.palette.grey[800]};
  padding:  ${props => props.theme.spacing(2)}; 
  padding-right: ${props => props.theme.spacing(1)}; 
  background-color: ${props => props.theme.layout.lightBackground};

  & svg {
    font-size: 2.5rem;    
  }
`;

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;

& svg {
    font-size: 1.1rem;
    margin-right: ${props => props.theme.spacing(0.5)}; 
  }
`;


const TitleTypography = styled(Typography)`
  display: flex;
  align-items: center;
  font-weight: 700;
`;

type Props = Pick<
  CheckoutStepProps,
  'adults' | 'pChildren' | 'infants' | 'pets' | 'startDate' | 'endDate' | 'userId'
> & {
  isLoading: boolean;
  propertyId: number | undefined;
  bookingQuoteTotal: string | undefined;
};


export const ContactBookNowButton = ({
  isLoading,
  propertyId,
  adults,
  pChildren,
  infants,
  pets,
  userId,
  startDate,
  endDate,
  bookingQuoteTotal,
}: Props) => {


  const loading = !bookingQuoteTotal || isLoading;

  const amountInCents = bookingQuoteTotal ? bookingQuoteTotal : 0;
  const fullAmount = formatCanadianCurrency(amountInCents, {
    minMaxFractionDigits: 2,
  });
  const datesDisplay = generateDatesDisplay({
    startDate: startDate,
    endDate: endDate,
  });

  const router = useRouter();

  const onClick = () => {
    router.push(
      {
        pathname: '/[propertyId]/reservenow',
        query: {
          adults,
          children: pChildren,
          infants,
          pets,
          startDate,
          endDate,
          userId,
          propertyId,
        },
      },
      undefined,
      { shallow: true, scroll: true },
    );
  };

  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={loading}>
        <StyledButton variant="outlined" fullWidth onClick={onClick} disabled={loading} color="secondary">
          <StyledBox>
            <LoadingSkeleton isLoading={loading}>
              <TitleTypography variant="body1"><CheckCircleIcon color="success" /> Dates are available<Hidden smDown> to be booked now</Hidden></TitleTypography>
            </LoadingSkeleton>
            <LoadingSkeleton isLoading={loading}>
              <Typography variant="body2">Reserve {datesDisplay} for {fullAmount} CAD</Typography>
            </LoadingSkeleton>
          </StyledBox>
          <ChevronRightIcon color="secondary" />
        </StyledButton>
      </LoadingSkeleton>
    </Grid>
  );
};
